// extracted by mini-css-extract-plugin
export default {"main":"TableBody_main__6uamL"};